import { gql } from '@apollo/client';

export const LINK_PROVIDER_TO_PATIENT = gql`
  mutation LinkPatientWithProvider($data: CreateProviderInput!) {
    linkPatientWithProvider(data: $data)
  }
`;
